export const menuText = {
    create_account: {
        'en': 'Create account',
        'fr': 'Créer un compte',
        'de': 'Konto erstellen',
        'ko': '계정 만들기',
        'ch': '创建账户',
        'ru': 'Создать аккаунт',
        'it': 'Crea un account',
        'jap': 'アカウント作成',
        'port': 'Criar conta',
        'turk': 'Hesap oluştur',
        'viet': 'Tạo tài khoản',
        'spa': 'Crear cuenta',
        'arab': 'إنشاء حساب'
    },
    terms: {
        'en': 'Terms',
        'fr': 'conditions d\'utilisation',
        'de': 'Nutzungsbedingungen',
        'ko': '이용약관',
        'ch': '条款和',
        'ru': 'Условиями',
        'it': 'Termini',
        'jap': 'とプライバシー ポリ',
        'port': 'Termos',
        'turk': 'Şartlar',
        'viet': 'Điều khoản',
        'spa': 'Términos',
        'arab': 'الشروط'
    },
    private: {
        'en': 'Privacy Policy',
        'fr': 'et la politique de confidentialité',
        'de': 'Datenschutzbestimmungen zu',
        'ko': '및 개인정보취급방침에',
        'ch': '隐私政策。',
        'ru': 'Политикой конфиденциальности',
        'it': 'Politiche sulla Privacy',
        'jap': '利用規約',
        'port': 'Política de Privacidade',
        'turk': 'Gizlilik Politikasını',
        'viet': 'Chính sách Bảo mật',
        'spa': 'Política de Privacidad',
        'arab': 'الخصوصية'
    },
    confirm_text: {
        'en': 'I consent to the',
        'fr': 'J\'accepte les',
        'de': 'Ich stimme den',
        'ko': '  동의합니다.',
        'ch': '我同意',
        'ru': 'Я согласен с',
        'it': 'Accetto i',
        'jap': 'シーに同意します。',
        'port': 'Eu concordo com os',
        'turk': 'Kabul ediyorum',
        'viet': 'Tôi đồng ý với các',
        'spa': 'Acepto los',
        'arab': 'أوافق على'
    },
    password: {
        'en': 'Set password',
        'fr': 'Configurez le mot de passe',
        'de': 'Passwort festlegen',
        'ko': '비밀번호 설정',
        'ch': '设置密码',
        'ru': 'Установить пароль',
        'it': 'Imposta password',
        'jap': 'パスワードを設定',
        'port': 'Configurar senha',
        'turk': 'Şifre belirle',
        'viet': 'Đặt mặt khẩu',
        'spa': 'Establecer contraseña',
        'arab': 'حدد كلمة السر'
    },
    name: {
        'en': 'First Name',
        'fr': 'Prénom',
        'de': 'Vorname',
        'ko': '이름',
        'ch': '名字',
        'ru': 'Имя',
        'it': 'Nome',
        'jap': '名',
        'port': 'Primeiro nome',
        'turk': 'İsim',
        'viet': 'Tên',
        'spa': 'Nombre',
        'arab': 'اسم'
    },
    surname: {
        'en': 'Surname',
        'fr': 'Nom',
        'de': 'Nachname',
        'ko': '성',
        'ch': '姓氏',
        'ru': 'Фамилия',
        'it': 'Cognome',
        'jap': '姓',
        'port': 'Sobrenome',
        'turk': 'Soyisim',
        'viet': 'Họ',
        'spa': 'Apellidos',
        'arab': 'لقب'
    },
    email: {
        'en': 'Email',
        'fr': 'Adresse e-mail',
        'de': 'E-Mail-Adresse',
        'ko': '이메일',
        'ch': '电子邮件',
        'ru': 'Почта',
        'it': 'Email',
        'jap': 'メールアドレス',
        'port': 'E-mail',
        'turk': 'E-posta',
        'viet': 'Email',
        'spa': 'Correo electrónico',
        'arab': '	بريد الالكتروني'
    },
    bep20: {
        'en': 'BEP20 wallet (to receive $ARTY)',
        'fr': 'Portefeuille BEP20 (pour $ARTY)',
        'de': 'BEP20-Wallet (zum $ARTY)',
        'ko': 'BEP20 지갑($ARTY 수신용)',
        'ch': 'BEP20 钱包（接收 $ARTY）',
        'ru': 'Кошелек BEP20 (для $ARTY)',
        'it': 'Portafoglio BEP20 (per $ARTY)',
        'jap': 'BEP20ウォレット（$ARTY受け取り用）',
        'port': 'Carteira BEP20 (para $ARTY)',
        'turk': 'BEP20 cüzdanı ($ARTY alımı için)',
        'viet': 'Ví BEP20 (để nhận ARTY$)',
        'spa': 'Monedero BEP20 (para $ARTY)',
        'arab': '	محفظة BEP20 (لتلقي $ARTY)'
    },				
    password: {
        'en': 'Password',
        'fr': 'Mot de passe',
        'de': 'Passwort',
        'ko': '비밀번호',
        'ch': '密码',
        'ru': 'Пароль',
        'it': 'Password',
        'jap': 'パスワード',
        'port': 'Senha',
        'turk': 'Şifre',
        'viet': 'Mật khẩu',
        'spa': 'Contraseña',
        'arab': '	كلمه السر'
    },										
    confirm_password: {
        'en': 'Confirm password',
        'fr': 'Confirmez le mot de passe',
        'de': 'Passwort bestätigen',
        'ko': '비밀번호 확인',
        'ch': '确认密码',
        'ru': 'Подтвердите пароль',
        'it': 'Conferma password',
        'jap': 'パスワードを確認',
        'port': 'Confirmar senha',
        'turk': 'Şifreyi doğrula',
        'viet': 'Xác nhận mật khẩu',
        'spa': 'Confirmar contraseña',
        'arab': '	تأكيد كلمة المرور'
    },										
    registration: {
        'en': 'Registration',
        'fr': 'S\'inscrire',
        'de': 'Registrieren',
        'ko': '등록',
        'ch': '登记',
        'ru': 'Регистрация',
        'it': 'Registrati',
        'jap': '登録',
        'port': 'Registrar',
        'turk': 'Kayıt Ol',
        'viet': 'Đăng ký',
        'spa': 'Registrarse',
        'arab': '	سج'
    },									
    back_site: {
        'en': 'Back to ARTYFACT website',
        'fr': 'Retour au site Web d\'ARTYFACT',
        'de': 'Zurück zur ARTYFACT-Website',
        'ko': 'Artyfact 웹사이트로 돌아가기',
        'ch': '返回 ARTYFACT 网站',
        'ru': 'Обратно к сайту Artyfact',
        'it': 'Torna al sito di Artyfact',
        'jap': 'ARTYFACTのWebサイトに戻る',
        'port': 'Voltar para o site ARTYFACT',
        'turk': 'ARTYFACT internet sitesine dön',
        'viet': 'Quay lại trang web ARTYFACT',
        'spa': 'Volver al sitio web de ARTYFACT',
        'arab': '	العودة إلى موقع ARTYFACT'
    },									
};